export const defaultTranslations = {
  uz: {
    // Navigation
    nav_home: 'Bosh sahifa',
    nav_about: 'Advokatlar haqida',
    nav_services: 'Amaliyotlar',
    nav_lawyers: 'Advokatlar',
    nav_offices: 'Ofislar va Xarita',
    nav_contact: 'Aloqa',
    nav_book_cta: 'Qabulga yozilish',
    nav_check_booking: 'Arizani tekshirish',

    // Hero Section
    hero_badge: 'Milliy Yuridik Amaliyot va Malakali Himoya',
    hero_category: 'Yuridik Yechimlar va Himoya',
    hero_headline_1: 'Sizning huquqlaringiz va biznesingiz',
    hero_headline_2: 'Ishonchli Himoyada',
    hero_headline: 'Sizning huquqlaringiz va biznesingiz ishonchli himoyada',
    hero_subheadline: 'Murakkab tijorat nizolari, korporativ bitimlar va jinoiy himoya bo‘yicha O‘zbekiston miqyosidagi yetakchi advokatlar jamoasi.',
    hero_cta_book: 'Konsultatsiyaga yozilish',
    hero_cta_lawyers: 'Advokatlarimiz bilan tanishing',
    hero_cta_practice: 'Bizning Amaliyotlarimiz',

    // Hero Benefit Badges
    badge_experienced: 'Tajribali Advokatlar',
    badge_experienced_desc: 'Oliy toifali sud va tergov tajribasi',
    badge_results: 'Ishonchli Natijalar',
    badge_results_desc: 'Murakkab ishlarda yutuqli yakun',
    badge_client: 'Mijozlar Manfaati',
    badge_client_desc: 'Shaxsiy yondashuv va to‘liq maxfiylik',

    // Quick Consultation Form (Hero Right)
    quick_consult_firm: 'Jizzax Advokatlari',
    quick_consult_title: 'Tezkor Konsultatsiya',
    quick_consult_desc: 'Mutaxassis bilan bog‘laning va dastlabki huquqiy yordam oling.',
    input_name: 'Ism va Familiya',
    input_email_opt: 'Elektron Pochta (ixtiyoriy)',
    input_reason_opt: 'Murojaat sababi (qisqacha)...',
    btn_submit_request: 'Arizani yuborish',
    quick_success_title: 'Arizangiz qabul qilindi!',
    quick_success_desc: 'Advokatlarimiz tez orada siz bilan bog‘lanishadi.',

    // Trust / Stats
    stat_years: 'Yillik tajriba',
    stat_cases: 'Ko‘rib chiqilgan ishlar va amaliyot',
    stat_lawyers: 'Oliy toifali advokatlar',
    stat_trust: 'Mijozlar ishonchi darajasi',

    // Middle Section ("We Fight For Justice")
    legal_ribbon_title: 'Yuridik Yordam va Strategik Himoya',
    fight_justice_title_1: 'Adolat Uchun',
    fight_justice_title_2: 'Kurashamiz',
    fight_justice_desc: 'Advokatlarimiz har bir mijozning huquqlari, erkinliklari va qonuniy manfaatlarini ijobiy va professional himoya qilishga asoslangan.',
    btn_learn_more: 'Advokatlar haqida batafsil',
    middle_statement_title: 'Yuqori Tajribaga Ega. Mukammal Himoya. Ijobiy Natija.',
    middle_statement_desc: 'Barcha sud va tergov bosqichlarida ishonchli yuridik himoya hamda advokatlik kafolati. Jizzax shahar, Islom Karimov ko‘chasi, Turon Bank ro‘parasi. Tel: +998 (97) 325-07-70',
    consultation_free_badge: 'Bizda konsultatsiya bepul',

    // Practice Areas / Topics
    topic_criminal: 'Jinoyat ishlari bo‘yicha himoya',
    topic_criminal_desc: 'Dastlabki tergov organlari, prokuratura va sudlarda fuqarolar hamda mansabdor shaxslarning huquqlarini professional himoya qilish.',
    topic_injury: 'Fuqarolik va yetkazilgan zarar',
    topic_injury_desc: 'Mulkka yoki sog‘liqqa yetkazilgan moddiy va ma’naviy zararlarni to‘liq hajmda undirish, sug‘urta kompensatsiyalari.',
    topic_business: 'Biznes va Korporativ huquq',
    topic_business_desc: 'Kompaniyalarni ta’sis etish, xo‘jalik shartnomalari, korporativ nizolar, investitsiyalar va yuridik autsorsing.',
    topic_family: 'Oila va meros nizolari',
    topic_family_desc: 'Meros taqsimoti, nikoh shartnomalari, er-xotin mulkini bo‘lish va voyaga yetmagan bolalar manfaatlarini kafolatlash.',
    topic_estate: 'Ko‘chmas mulk va investitsiyalar',
    topic_estate_desc: 'Yirik yer uchastkalari, tijorat ko‘chmas mulk bitimlari tozaligi, kadastr nizolari va qurilish shartnomalari.',

    // Section Titles
    sec_services_badge: 'Bizning ixtisoslashuvimiz',
    sec_services_title: 'Asosiy Amaliyot Yo‘nalishlari',
    sec_services_desc: 'Biznesingiz va shaxsiy manfaatlaringizni qonuniy kafolatlash uchun keng qamrovli yuridik yordam.',
    sec_lawyers_badge: 'Bizning jamoa',
    sec_lawyers_title: 'Yetakchi Advokatlar Jamoasi',
    sec_lawyers_desc: 'Oliy toifali litsenziyaga va ko‘p yillik sud tajribasiga ega bo‘lgan yetakchi advokatlar.',
    sec_why_badge: 'Nega biz?',
    sec_why_title: 'Advokatlik Faoliyatimiz Tamoyillari',
    sec_testimonials_badge: 'Mijozlar e’tirofi',
    sec_testimonials_title: 'Ishonch va Erishilgan Natijalar',
    sec_offices_badge: 'Joylashuv',
    sec_offices_title: 'Ofislarimiz va Ish Vaqti',

    // Lawyer Cards & Dossier
    lawyers_team_title: 'Yetakchi Advokatlar Jamoasi',
    view_all_lawyers: 'Barcha advokatlarni ko‘rish',
    lawyer_detail_btn: 'Batafsil →',
    lawyer_dossier_title: 'Advokat Dossyesi va Ma’lumotlari',
    lawyer_workplace: 'Ishxona Manzili va Ofis',
    lawyer_contacts: 'To‘g‘ridan-to‘g‘ri Aloqa Vositalari',
    lawyer_specialty: 'Ixtisoslashuv',
    lawyer_experience: 'Sud va himoya tajribasi',
    telegram_account: 'Telegram akkount',
    instagram_account: 'Instagram sahifa',
    qualifications_bio: 'Kasbiy Malaka va Biografiya',
    education_title: 'Oliy Ma’lumot',
    certifications_title: 'Litsenziya va Sertifikatlar',

    // Online Booking Section
    online_booking_badge: 'ONLAYN BRON QILISH',
    online_booking_title: 'Qabulga Yozilish Tizimi',
    online_booking_desc: 'O‘zingizga qulay sana va vaqtni tanlang. Ma’muriyat arizangizni zudlik bilan ko‘rib chiqadi va rasmiy tasdiqnoma taqdim etadi.',

    // Booking Steps
    step_1: 'Xizmat turi',
    step_2: 'Advokat',
    step_3: 'Ofis',
    step_4: 'Sana & Vaqt',
    step_5: 'Ma’lumotlar',
    step_6: 'Murojaat sababi',
    step_7: 'Tasdiqlash',

    // Booking Form
    select_service: 'Yuridik xizmat turini tanlang',
    select_lawyer: 'Advokatni tanlang',
    select_office: 'Qabul ofisini tanlang',
    select_date_time: 'Qulay sana va mavjud vaqt oralig‘ini belgilang',
    your_name: 'To‘liq ism-familiyangiz',
    your_phone: 'Telefon raqamingiz',
    your_email: 'Elektron pochta manzilingiz',
    consultation_reason: 'Konsultatsiya mavzusi va qisqacha sababi',
    reason_placeholder: 'Murojaat sababini qisqacha yozing (kamida 10 ta belgi)...',
    reason_hint: 'Kamida 10 ta belgi talab qilinadi. Bu advokatga oldindan tayyorgarlik ko‘rish imkonini beradi.',
    slot_available: 'Bo‘sh',
    slot_booked: 'Band',
    slot_break: 'Tushlik',
    btn_next: 'Keyingi bosqich',
    btn_prev: 'Orqaga',
    btn_confirm_submit: 'Arizani rasmiylashtirish',
    submitting: 'Yuborilmoqda...',

    // Booking Confirmation
    booking_success_title: 'Arizangiz qabul qilindi!',
    booking_ref_label: 'Sizning bron raqamingiz:',
    booking_status_label: 'Hozirgi holat:',
    booking_next_step: 'Advokatlar ma’muriyati tez orada arizangizni ko‘rib chiqadi va tasdiqlash xabarini ko‘rsatilgan telefon raqamingizga yuboradi.',
    check_status_btn: 'Ariza holatini kuzatish',
    book_another_btn: 'Yangi ariza qoldirish',

    // Status Lookup
    lookup_title: 'Ariza holatini tekshirish',
    lookup_subtitle: 'Bron raqamingiz va telefon raqamingiz orqali konsultatsiya tasdiqlanganligini bilib oling',
    lookup_ref_placeholder: 'Masalan: APT-2026-000001',
    lookup_contact_placeholder: '+998 (97) 325-07-70',
    lookup_submit: 'Tekshirish',
    searching: 'Qidirilmoqda...',

    // Status Badges
    status_pending: 'Ko‘rib chiqilmoqda (Pending)',
    status_confirmed: 'Tasdiqlangan (Confirmed)',
    status_rejected: 'Rad etilgan (Rejected)',
    status_cancelled: 'Bekor qilingan (Cancelled)',
    status_completed: 'Muvaffaqiyatli yakunlangan',
    status_no_show: 'Mijoz kelmadi (No-show)',

    // Common
    lawyer_experience_suffix: 'yillik tajriba',
    view_details: 'Batafsil ma’lumot',
    all_rights_reserved: 'Barcha huquqlar himoyalangan',
    privacy_policy: 'Maxfiylik siyosati',
    terms_of_service: 'Foydalanish shartlari',
    disclaimer: 'Yuridik ogohlantirish',
    contact_us: 'Biz bilan bog‘laning',
    working_hours_label: 'Ish tartibi',
    admin_panel_title: 'Admin Boshqaruv',

    // Extra UI & Booking & Modals
    my_profile: 'Mening Profilim',
    auth_login: 'Kirish',
    logout: 'Chiqish',
    login_register: 'Kirish / Ro‘yxatdan o‘tish',
    book_appointment_panel: 'QABULGA YOZILISH',
    choose_date_time_panel: 'SANA VA VAQTNI TANLANG',
    your_information_panel: 'SIZNING MA’LUMOTLARINGIZ',
    submit_appointment_btn: 'ARIZANI YUBORISH',
    confirm_appointment_title: 'Arizani Tasdiqlash',
    confirm_appointment_subtitle: 'Iltimos, kiritilgan ma’lumotlarni tekshiring va arizani yuborishni tasdiqlang',
    confirm_btn_yes: 'HA, TASDIQLAYMAN',
    cancel_btn: 'Bekor qilish',
    service_and_lawyer: 'Xizmat va Advokat:',
    date_and_time: 'Sana va Vaqt:',
    applicant: 'Ariza Beruvchi:',
    reason_for_visit: 'Murojaat sababi:',
    sms_notice_hint: 'Tasdiqlash tugmasini bosganingizdan so‘ng arizangiz adminga kelib tushadi. Ma’muriyat arizani qabul qilgach yoki tasdiqlagach, telefoningizga SMS hamda shaxsiy profilingizdagi qo‘ng‘iroqchaga bildirishnoma yuboriladi.',
    legal_solutions_tag: 'YURIDIK YECHIMLAR',
    hero_title_p1: 'Sizning Qonuniy',
    hero_title_p2: 'Huquqlaringizni Himoya',
    hero_title_highlight: 'Qilishga Bag‘ishlangan',
    hero_schedule_consult: 'KONSULTATSIYAGA YOZILISH',
    hero_our_practices: 'AMALIYOT YO‘NALISHLARI',
    reviews_badge: 'Mijozlar E’tirofi',
    reviews_title: 'Mijozlarimiz Fikrlari va Izohlar',
    reviews_subtitle: 'Bizning yuridik himoyamizdan foydalangan mijozlarning xolis e’tirofi va mulohazalari',
    practice_catalog_title: 'Yuridik Amaliyot Katalogi',
    practice_overview: 'Yo‘nalish haqida umumiy ma’lumot',
    practice_services_offered: 'Katalog bo‘yicha ko‘rsatiladigan aniq xizmatlar',
    stat_success_rate: 'Muvaffaqiyatli sud va muzokara natijalari',
    stat_senior_exp: 'Oliy toifali advokatlik staji',
    stat_confidentiality: 'Maxfiylik va advokatlik siri kafolati',
    lead_attorneys: 'Ushbu soha bo‘yicha mas’ul bosh advokatlar',
    preliminary_review_time: 'Dastlabki yuridik ekspertiza: 24 soat ichida',
    close_btn: 'Yopish',
    book_in_this_field: 'Ushbu yo‘nalishda uchrashuv belgilash',
    firm_name_badge: 'JIZZAX ADVOKATLARI',
    firm_location_brief: 'Jizzax shahar, Turon Bank ro‘parasi',
    call_phone_number: 'Telefon: +998 (97) 325-07-70',
    available_time_slots: 'Mavjud Vaqt Oraliqlari',
    slots_checking: 'Vaqtlar tekshirilmoqda...',
    no_slots_available: 'Ushbu sanada advokat qabuli mavjud emas. Boshqa kunni tanlang.',
    office_address_label: 'Manzil',
    office_phone_label: 'Telefon',
    office_hours_label: 'Ish Tartibi',
    office_book_btn: 'Ushbu ofisda qabulga yozilish',
    corporate_client: 'Mijoz',
    rate_lawyer_title: 'Advokatga Baho Berish',
    rate_lawyer_subtitle: 'Advokat xizmati sifati bo‘yicha 1 dan 5 gacha baho bering va xolis izohingizni qoldiring',
    select_lawyer_label: 'Advokatni tanlang *',
    select_lawyer_placeholder: '— Advokatni tanlang —',
    rating_stars_label: 'Baho (1 dan 5 gacha yulduz) *',
    client_name_label: 'Ismingiz va Familiyangiz *',
    client_name_placeholder: 'Masalan: Sardor Rahimov',
    client_title_label: 'Kasbingiz yoki Tashkilotingiz (Ixtiyoriy)',
    client_title_placeholder: 'Masalan: «Delta Agro» MCHJ rahbari',
    comment_label: 'Izoh va Mulohazangiz (Majburiy) *',
    comment_placeholder: 'Advokatning ishi, maslahati va natijasi haqida batafsil yozing (kamida 10 ta belgi)...',
    submit_review_btn: 'Bahoni va Fikrni Yuborish',
    review_submitted_title: 'Bahoingiz Muvaffaqiyatli Qabul Qilindi!',
    review_submitted_subtitle: 'Advokatimiz faoliyatiga bildirgan xolis fikringiz va bahoingiz uchun minnatdorchilik bildiramiz.',
    back_to_home: 'Bosh sahifaga qaytish',
    new_booking: 'Yangi qabulga yozilish',
    client_portal_tag: 'MIJOZLAR PORTALI',
    booking_id_label: 'Bron Raqami (Booking ID) *',
    phone_or_email_label: 'Telefon yoki Email *',
    check_status_btn_text: 'Holatni tekshirish',
    nav_book_short: 'Qabul',
    rate_lawyer_tooltip: 'Advokatga baho berish',
    admin_login_short: 'Admin',
    select_language: 'Tilni tanlang',
    about_philosophy_tag: 'BIZNING FALSAFAMIZ VA QADRIYATLAR',
    about_mission_title: 'Bizning Missiyamiz va Professional Falsafamiz',
    about_mission_desc_1: 'Jizzax Advokatlari — O‘zbekistonda yetakchi yuridik amaliyot jamoalaridan biridir. Biz mijozlarimizga shunchaki maslahat bermaymiz, balki ularning buzilgan huquqlarini tiklashda kafolatlovchi strategik yechimlarni taqdim etamiz.',
    about_mission_desc_2: 'Jamoamiz a’zolari Oliy toifali advokat litsenziyalariga ega bo‘lib, murakkab aksiyadorlik nizolari, sud himoyasi va yirik iqtisodiy ishlarda yuksak natijalarga erishgan.',
    pillar_rule_of_law: 'Qonun Ustuvorligi',
    pillar_rule_of_law_desc: 'Har qanday vaziyatda qonun talablariga to‘liq rioya qilgan holda, mijoz manfaatlarini eng yuqori darajada ijobiy himoya qilish.',
    pillar_confidentiality: 'Maxfiylik Kafolati',
    pillar_confidentiality_desc: 'Advokatlik siri va barcha hujjatlar, suhbatlar daxlsizligi to‘liq himoyalangan va kafolatlangan.',
    pillar_results: 'Amaliy Natija',
    pillar_results_desc: 'Mavhum tavsiyalar emas, balki real sud va shartnoma amaliyotida ishlaydigan strategiyalar.',
    navigation_title: 'Navigatsiya',
    developer_author_label: 'Dasturchi va Muallif:',
    rating_1: '1 - Juda qoniqarsiz',
    rating_2: '2 - Qoniqarsiz',
    rating_3: '3 - O‘rtacha',
    rating_4: '4 - Yaxshi',
    rating_5: '5 - A’lo darajada (Tavsiya qilaman)',
    office_details_title: 'Markaziy Bosh Ofis Rekvizitlari',
    emergency_call_title: 'SHOSHILINCH ADVOKAT CHAQIRUVI (24/7)',
    emergency_call_desc: 'Qamoqqa olish, tergov harakatlari yoki kechiktirib bo‘lmaydigan tintuvlarda shoshilinch advokat xizmati:',
    quick_msg_title: 'Tezkor Xabar Qoldirish',
    msg_content_label: 'Xabar Mazmuni',
    msg_content_placeholder: 'Savolingiz yoki yuridik masala haqida qisqacha...',
    send_msg_btn: 'XABARNI YUBORISH',
    msg_sent_title: 'Xabaringiz Qabul Qilindi',
    msg_sent_desc: 'Advokatlarimiz tez orada siz bilan bog‘lanadi.',
    email_label: 'Elektron Pochta',
    phone_or_email_label: 'Telefon Raqami',
    book_appointment_sub: 'Advokatlar Qabuliga Yozilish',
    free_consultation_badge: 'Bizda konsultatsiya bepul',
    notif_modal_badge: 'Bildirishnoma Tafsilotlari',
    book_button: 'Qabul',
    phone_label: 'Telefon raqami',
    contact_page_desc: 'Savollaringiz yoki shoshilinch yuridik yordam zarurati bo‘yicha to‘g‘ridan-to‘g‘ri murojaat qiling.',
    senior_partner: 'Katta Advokat',
    office_phone_label: 'Telefon raqami',
    specialistsTag: 'MALAKALI ADVOKATLAR & HUQUQSHUNOSLAR',
    search_lawyers_placeholder: 'Advokat ismi, ixtisosligi yoki soha bo‘yicha izlash...',
    bookConsultation: 'Qabulga yozilish',

    // Auth & Subscription
    sub_monthly_menu: 'Oylik Obuna',
    lawyer_cabinet_menu: 'Advokat Kabineti',
    sub_modal_badge_client: 'Mijoz Shaxsiy Kabineti',
    sub_modal_badge_lawyer: 'Advokat Shaxsiy Kabineti',
    sub_modal_title: '30 Kunlik Oylik Obuna',
    sub_price_label: 'Oylik to‘lov summasi:',
    sub_tariff_client: '(Mijoz tarifi • 35 000 so‘m/oy)',
    sub_tariff_lawyer: '(Advokat tarifi • 99 000 so‘m/oy)',
    sub_period_badge: '30 kunlik muddat',
    sub_step1_title: '1-Qadam: Click yoki Payme orqali to‘lash',
    sub_click_btn: 'Click Up orqali',
    sub_payme_btn: 'Payme orqali',
    sub_open_app: 'Ilovani ochish',
    sub_card_label: 'To‘lov o‘tkaziladigan rasmiy karta:',
    sub_copy_card: 'Nusxalash',
    sub_copied: 'Nusxalandi',
    sub_auto_copy_hint: 'Click yoki Payme orqali to‘lov qilganda karta raqami avtomatik nusxalanadi.',
    sub_step2_title: '2-Qadam: Telefon raqam va Tasdiqlash',
    sub_complete_badge: 'To‘liq',
    sub_phone_label: 'To‘lovchi Telefon Raqami (Click / Payme) *',
    sub_phone_hint: 'Faqat raqamlar kiritiladi: +998 (97) 325-07-70',
    sub_name_label: 'Ism va familiyangiz (Ixtiyoriy)',
    sub_name_placeholder: 'Masalan: Ali Valiyev',
    sub_password_label: 'Parol yaratish (Ixtiyoriy - kelgusida kirish uchun)',
    sub_password_placeholder: 'Kamida 6 ta belgi',
    sub_receipt_label: 'To‘lov cheki yoki skrinshot (ixtiyoriy):',
    sub_receipt_select: 'Chek rasmi yoki PDF tanlang',
    sub_receipt_uploading: 'Yuklanmoqda...',
    sub_receipt_attached: '✓ Chek muvaffaqiyatli biriktirildi',
    sub_notes_placeholder: 'Tranzaksiya ID si yoki chek kodi (ixtiyoriy)...',
    sub_btn_cancel: 'Bekor qilish',
    sub_btn_confirm: 'To‘lov qildim (Tasdiqlash)',
    sub_btn_verifying: 'Tekshirilmoqda...',
    sub_active_title: 'To‘lov Tasdiqlandi va Obuna Faollashtirildi!',
    sub_active_desc: 'Sizning akkauntingiz keyingi 30 kunga to‘liq faollashtirildi. Barcha advokatlarning shaxsiy aloqa raqamlari va maxfiy chat ochildi.',
    sub_continue: 'Ishni davom ettirish',
    
    // Auth Modal
    auth_login_title: 'Tizimga Kirish',
    auth_login_subtitle: 'Advokat, mijoz va ma’muriy xodimlar uchun',
    auth_login_input_label: 'Login, Telefon Raqam yoki Email',
    auth_login_input_placeholder: 'Login, telefon raqam yoki email',
    auth_password_label: 'Parol',
    auth_password_placeholder: 'Kamida 6 ta belgi',
    auth_2fa_title: '2-bosqich maxfiy xavfsizlik parolini kiriting',
    auth_2fa_label: '2-Bosqich Paroli',
    auth_btn_submit: 'TIZIMGA KIRISH',
    auth_btn_2fa_submit: '2-BOSQICHNI TASDIQLASH VA KIRISH',
    auth_new_user_title: 'Yangi foydalanuvchimisiz?',
    auth_new_user_desc: 'Yuridik yordam olish, advokatlar bilan bevosita bog‘lanish va shaxsiy akkaunt ochish 30 kunlik oylik obuna to‘lovi orqali amalga oshiriladi.',
    auth_new_user_cta: 'Obuna to‘lash va Akkaunt ochish (35 000 so‘m)',
    auth_security_guarantee: 'Ma’lumotlar shifrlangan va advokatlik siriga binoan himoyalangan',
  },

  ru: {
    // Navigation
    nav_home: 'Главная',
    nav_about: 'Об адвокатах',
    nav_services: 'Практики',
    nav_lawyers: 'Адвокаты',
    nav_offices: 'Офисы и Карта',
    nav_contact: 'Контакты',
    nav_book_cta: 'Запись на приём',
    nav_check_booking: 'Статус заявки',

    // Hero Section
    hero_badge: 'Национальная Юридическая Практика',
    hero_category: 'Правовая Защита и Консалтинг',
    hero_headline_1: 'Надежная защита ваших прав',
    hero_headline_2: 'И Интересов Бизнеса',
    hero_headline: 'Безупречная защита ваших прав и интересов бизнеса',
    hero_subheadline: 'Команда признанных адвокатов высшей квалификации по сложным коммерческим спорам, инвестиционным сделкам и уголовной защите.',
    hero_cta_book: 'Записаться на консультацию',
    hero_cta_lawyers: 'Наши адвокаты',
    hero_cta_practice: 'Наши Практики',

    // Hero Benefit Badges
    badge_experienced: 'Опытные Адвокаты',
    badge_experienced_desc: 'Многолетний опыт в судах и следствии',
    badge_results: 'Реальные Результаты',
    badge_results_desc: 'Успешный исход в сложных делах',
    badge_client: 'Интересы Доверителя',
    badge_client_desc: 'Индивидуальный подход и конфиденциальность',

    // Quick Consultation Form (Hero Right)
    quick_consult_firm: 'Адвокаты Джизака',
    quick_consult_title: 'Экспресс-Консультация',
    quick_consult_desc: 'Свяжитесь со специалистом для оперативной первичной правовой помощи.',
    input_name: 'Имя и Фамилия',
    input_email_opt: 'Электронная почта (необязательно)',
    input_reason_opt: 'Суть вопроса (кратко)...',
    btn_submit_request: 'Отправить заявку',
    quick_success_title: 'Заявка принята!',
    quick_success_desc: 'Наши адвокаты свяжутся с вами в ближайшее время.',

    // Trust / Stats
    stat_years: 'Лет юридической практики',
    stat_cases: 'Рассмотренных дел и практика',
    stat_lawyers: 'Адвокатов высшей категории',
    stat_trust: 'Уровень доверия доверителей',

    // Middle Section ("We Fight For Justice")
    legal_ribbon_title: 'Правовая Помощь и Стратегическая Защита',
    fight_justice_title_1: 'Борьба За',
    fight_justice_title_2: 'Справедливость',
    fight_justice_desc: 'Наша команда адвокатов построена на принципах честности, профессиональной этики и бескомпромиссной защиты законных прав доверителей.',
    btn_learn_more: 'Подробнее об адвокатах',
    middle_statement_title: 'Высокий Опыт. Безупречная Защита. Положительный Результат.',
    middle_statement_desc: 'Надежная защита на всех стадиях следствия и суда. г. Джизак, улица Ислама Каримова, напротив Турон Банка. Тел: +998 (97) 325-07-70',
    consultation_free_badge: 'Консультация бесплатная',

    // Practice Areas / Topics
    topic_criminal: 'Уголовно-правовая защита',
    topic_criminal_desc: 'Профессиональная защита прав граждан и должностных лиц на следствии, в прокуратуре и во всех судебных инстанциях.',
    topic_injury: 'Гражданские споры и возмещение ущерба',
    topic_injury_desc: 'Взыскание материального и морального ущерба в полном объёме, страховые выплаты и судебная компенсация.',
    topic_business: 'Корпоративное право и бизнес',
    topic_business_desc: 'Учреждение компаний, хозяйственные договоры, корпоративные конфликты, инвестиции и абонентское обслуживание.',
    topic_family: 'Семейные и наследственные споры',
    topic_family_desc: 'Раздел имущества, брачные договоры, вступление в наследство и защита интересов несовершеннолетних.',
    topic_estate: 'Недвижимость и инвестиции',
    topic_estate_desc: 'Юридическая проверка сделок с землей и коммерческой недвижимостью, кадастровые споры и строительные договоры.',

    // Section Titles
    sec_services_badge: 'Специализация',
    sec_services_title: 'Ключевые Практики и Услуги',
    sec_services_desc: 'Комплексная правовая поддержка для бизнеса и частных доверителей в соответствии с высшими стандартами.',
    sec_lawyers_badge: 'Наша команда',
    sec_lawyers_title: 'Партнеры и Старшие Адвокаты',
    sec_lawyers_desc: 'Ведущие эксперты с лицензиями высшей категории и признанным опытом в судах.',
    sec_why_badge: 'Принципы работы',
    sec_why_title: 'Стандарты Адвокатской Деятельности',
    sec_testimonials_badge: 'Отзывы доверителей',
    sec_testimonials_title: 'Доверие и Достигнутые Результаты',
    sec_offices_badge: 'Локации',
    sec_offices_title: 'Наши Офисы и График Приёма',

    // Lawyer Cards & Dossier
    lawyers_team_title: 'Команда Ведущих Адвокатов',
    view_all_lawyers: 'Посмотреть всех адвокатов',
    lawyer_detail_btn: 'Подробнее →',
    lawyer_dossier_title: 'Досье и Данные Адвоката',
    lawyer_workplace: 'Рабочий Офис и Место Приёма',
    lawyer_contacts: 'Прямые Контакты и Мессенджеры',
    lawyer_specialty: 'Специализация',
    lawyer_experience: 'Стаж работы в судах',
    telegram_account: 'Telegram аккаунт',
    instagram_account: 'Instagram страница',
    qualifications_bio: 'Квалификация и Биография',
    education_title: 'Высшее Образование',
    certifications_title: 'Лицензии и Аттестация',

    // Online Booking Section
    online_booking_badge: 'ОНЛАЙН ЗАПИСЬ',
    online_booking_title: 'Система Записи на Приём',
    online_booking_desc: 'Выберите удобную дату и время. Администрация оперативно рассмотрит заявку и направит официальное подтверждение.',

    // Booking Steps
    step_1: 'Услуга',
    step_2: 'Адвокат',
    step_3: 'Офис',
    step_4: 'Дата и время',
    step_5: 'Данные',
    step_6: 'Суть вопроса',
    step_7: 'Подтверждение',

    // Booking Form
    select_service: 'Выберите сферу права или услугу',
    select_lawyer: 'Выберите адвоката',
    select_office: 'Выберите удобный офис',
    select_date_time: 'Выберите дату и доступный интервал времени',
    your_name: 'ФИО доверителя',
    your_phone: 'Контактный телефон',
    your_email: 'Электронная почта',
    consultation_reason: 'Суть вопроса и причина обращения',
    reason_placeholder: 'Опишите ваш правовой вопрос подробно (минимум 10 символов)...',
    reason_hint: 'Минимум 10 символов. Это необходимо адвокату для предварительного анализа вопроса.',
    slot_available: 'Свободно',
    slot_booked: 'Занято',
    slot_break: 'Обед',
    btn_next: 'Далее',
    btn_prev: 'Назад',
    btn_confirm_submit: 'Отправить заявку',
    submitting: 'Отправка заявки...',

    // Booking Confirmation
    booking_success_title: 'Заявка успешно принята!',
    booking_ref_label: 'Номер вашей брони:',
    booking_status_label: 'Текущий статус:',
    booking_next_step: 'Администрация юридической фирмы рассмотрит заявку и направит подтверждение с комментарием на ваш email и телефон.',
    check_status_btn: 'Проверить статус записи',
    book_another_btn: 'Подать новую заявку',

    // Status Lookup
    lookup_title: 'Проверка статуса записи',
    lookup_subtitle: 'Введите номер брони и телефон/email для получения актуального статуса консультации',
    lookup_ref_placeholder: 'Например: APT-2026-000001',
    lookup_contact_placeholder: '+998 (97) 325-07-70',
    lookup_submit: 'Проверить статус',
    searching: 'Поиск...',

    // Status Badges
    status_pending: 'На рассмотрении (Pending)',
    status_confirmed: 'Подтверждено (Confirmed)',
    status_rejected: 'Отклонено (Rejected)',
    status_cancelled: 'Отменено (Cancelled)',
    status_completed: 'Консультация проведена',
    status_no_show: 'Доверитель не явился',

    // Common
    lawyer_experience_suffix: 'лет опыта',
    view_details: 'Подробнее',
    all_rights_reserved: 'Все права защищены',
    privacy_policy: 'Политика конфиденциальности',
    terms_of_service: 'Условия использования',
    disclaimer: 'Правовое уведомление',
    contact_us: 'Связаться с нами',
    working_hours_label: 'Часы работы',
    admin_panel_title: 'Панель Управления',

    // Extra UI & Booking & Modals
    my_profile: 'Мой Профиль',
    auth_login: 'Войти',
    logout: 'Выйти',
    login_register: 'Вход / Регистрация',
    book_appointment_panel: 'ЗАПИСЬ НА ПРИЁМ',
    choose_date_time_panel: 'ВЫБЕРИТЕ ДАТУ И ВРЕМЯ',
    your_information_panel: 'ВАШИ ДАННЫЕ',
    submit_appointment_btn: 'ОТПРАВИТЬ ЗАЯВКУ',
    confirm_appointment_title: 'Подтверждение Заявки',
    confirm_appointment_subtitle: 'Пожалуйста, проверьте введённые данные и подтвердите отправку анкеты',
    confirm_btn_yes: 'ДА, ПОДТВЕРЖДАЮ',
    cancel_btn: 'Отмена',
    service_and_lawyer: 'Услуга и Адвокат:',
    date_and_time: 'Дата и Время:',
    applicant: 'Заявитель:',
    reason_for_visit: 'Суть обращения:',
    sms_notice_hint: 'После подтверждения заявка поступит в коллегию. При одобрении вам поступит SMS на указанный номер и уведомление в колокольчик профиля.',
    legal_solutions_tag: 'ПРАВОВЫЕ РЕШЕНИЯ',
    hero_title_p1: 'Преданная Защита',
    hero_title_p2: 'Ваших Законных',
    hero_title_highlight: 'Прав и Интересов',
    hero_schedule_consult: 'ЗАПИСАТЬСЯ НА КОНСУЛЬТАЦИЮ',
    hero_our_practices: 'НАШИ ПРАКТИКИ',
    reviews_badge: 'Отзывы Доверителей',
    reviews_title: 'Мнения Наших Доверителей и Отзывы',
    reviews_subtitle: 'Честные отзывы граждан и компаний, чьи интересы мы защитили в суде и следствии',
    practice_catalog_title: 'Каталог Юридической Практики',
    practice_overview: 'Обзор направления практики',
    practice_services_offered: 'Перечень оказываемых юридических услуг',
    stat_success_rate: 'Успешные судебные исходы',
    stat_senior_exp: 'Стаж высшей адвокатской практики',
    stat_confidentiality: 'Гарантия адвокатской тайны',
    lead_attorneys: 'Ведущие адвокаты направления',
    preliminary_review_time: 'Первичная правовая экспертиза: в течение 24 часов',
    close_btn: 'Закрыть',
    book_in_this_field: 'Записаться по данному направлению',
    firm_name_badge: 'АДВОКАТЫ ДЖИЗАКА',
    firm_location_brief: 'г. Джизак, напротив Турон Банка',
    call_phone_number: 'Телефон: +998 (97) 325-07-70',
    available_time_slots: 'Доступные Интервалы Времени',
    slots_checking: 'Проверка доступных интервалов...',
    no_slots_available: 'На эту дату приёма нет. Пожалуйста, выберите другой день.',
    office_address_label: 'Адрес',
    office_hours_label: 'График работы',
    office_book_btn: 'Записаться на приём в этом офисе',
    corporate_client: 'Доверитель',
    rate_lawyer_title: 'Оценка Работы Адвоката',
    rate_lawyer_subtitle: 'Оцените качество юридической помощи от 1 до 5 звезд и оставьте объективный отзыв',
    select_lawyer_label: 'Выберите адвоката *',
    select_lawyer_placeholder: '— Выберите адвоката —',
    rating_stars_label: 'Оценка (от 1 до 5 звёзд) *',
    client_name_label: 'Ваше Имя и Фамилия *',
    client_name_placeholder: 'Например: Сардор Рахимов',
    client_title_label: 'Профессия или Организация (Необязательно)',
    client_title_placeholder: 'Например: Руководитель ООО «Delta Agro»',
    comment_label: 'Ваш Отзыв и Комментарий (Обязательно) *',
    comment_placeholder: 'Опишите подробно консультацию, стратегию и результат (минимум 10 символов)...',
    submit_review_btn: 'Отправить Отзыв и Оценку',
    review_submitted_title: 'Ваш Отзыв Успешно Принят!',
    review_submitted_subtitle: 'Благодарим вас за объективную оценку и отзыв о работе нашего адвоката.',
    back_to_home: 'Назад на главную',
    new_booking: 'Новая запись на приём',
    client_portal_tag: 'ПОРТАЛ ДОВЕРИТЕЛЕЙ',
    booking_id_label: 'Номер Брони (Booking ID) *',
    phone_or_email_label: 'Телефон или Email *',
    check_status_btn_text: 'Проверить статус',
    nav_book_short: 'Приём',
    rate_lawyer_tooltip: 'Оценить адвоката',
    admin_login_short: 'Админ',
    select_language: 'Выберите язык',
    about_philosophy_tag: 'НАША ФИЛОСОФИЯ И ЦЕННОСТИ',
    about_mission_title: 'Наша Миссия и Профессиональная Философия',
    about_mission_desc_1: '«Jizzax Advokatlari» — ведущая команда юридической практики в Узбекистане. Мы предлагаем стратегические решения, направленные на восстановление и защиту нарушенных прав наших доверителей.',
    about_mission_desc_2: 'Адвокаты имеют лицензии высшей категории и успешный опыт ведения сложных экономических, хозяйственных и уголовных дел в судах.',
    pillar_rule_of_law: 'Верховенство Права',
    pillar_rule_of_law_desc: 'Бескомпромиссная защита законных прав доверителя в строгом соответствии с требованиями закона.',
    pillar_confidentiality: 'Гарантия Конфиденциальности',
    pillar_confidentiality_desc: 'Абсолютная адвокатская тайна и неприкосновенность документов и консультаций.',
    pillar_results: 'Практический Результат',
    pillar_results_desc: 'Точные, работающие стратегии в суде и договорной практике вместо абстрактных советов.',
    navigation_title: 'Навигация',
    developer_author_label: 'Разработчик и Автор:',
    rating_1: '1 - Крайне неудовлетворительно',
    rating_2: '2 - Неудовлетворительно',
    rating_3: '3 - Удовлетворительно',
    rating_4: '4 - Хорошо',
    rating_5: '5 - Отлично (Рекомендую)',
    office_details_title: 'Реквизиты Центрального Офиса',
    emergency_call_title: 'СРОЧНЫЙ ВЫЗОВ АДВОКАТА (24/7)',
    emergency_call_desc: 'Срочная помощь адвоката при задержании, следственных действиях или неотложных обысках:',
    quick_msg_title: 'Оставить Быстрое Сообщение',
    msg_content_label: 'Текст Сообщения',
    msg_content_placeholder: 'Кратко о вашем вопросе или юридической проблеме...',
    send_msg_btn: 'ОТПРАВИТЬ СООБЩЕНИЕ',
    msg_sent_title: 'Ваше Сообщение Принято',
    msg_sent_desc: 'Наши адвокаты свяжутся с вами в ближайшее время.',
    email_label: 'Электронная Почта',
    phone_or_email_label: 'Номер Телефона',
    book_appointment_sub: 'Запись на прием к адвокату',
    free_consultation_badge: 'У нас консультация бесплатная',
    notif_modal_badge: 'Детали уведомления',
    book_button: 'Запись',
    phone_label: 'Номер телефона',
    contact_page_desc: 'Свяжитесь с нами напрямую по любым вопросам или для срочной юридической помощи.',
    senior_partner: 'Старший адвокат',
    office_phone_label: 'Номер телефона',
    specialistsTag: 'КВАЛИФИЦИРОВАННЫЕ АДВОКАТЫ И ЮРИСТЫ',
    search_lawyers_placeholder: 'Поиск адвоката по имени, специализации или отрасли...',
    bookConsultation: 'Записаться на консультацию',

    // Auth & Subscription
    sub_monthly_menu: 'Ежемесячная подписка',
    lawyer_cabinet_menu: 'Кабинет Адвоката',
    sub_modal_badge_client: 'Кабинет Доверителя',
    sub_modal_badge_lawyer: 'Кабинет Адвоката',
    sub_modal_title: 'Ежемесячная подписка на 30 дней',
    sub_price_label: 'Сумма ежемесячной оплаты:',
    sub_tariff_client: '(Тариф доверителя • 35 000 сум/мес)',
    sub_tariff_lawyer: '(Тариф адвоката • 99 000 сум/мес)',
    sub_period_badge: 'Срок: 30 дней',
    sub_step1_title: 'Шаг 1: Оплатите через Click или Payme',
    sub_click_btn: 'Через Click Up',
    sub_payme_btn: 'Через Payme',
    sub_open_app: 'Открыть приложение',
    sub_card_label: 'Официальная карта для перевода:',
    sub_copy_card: 'Копировать',
    sub_copied: 'Скопировано',
    sub_auto_copy_hint: 'При нажатии на Click или Payme номер карты копируется автоматически.',
    sub_step2_title: 'Шаг 2: Номер телефона и подтверждение',
    sub_complete_badge: 'Заполнено',
    sub_phone_label: 'Номер телефона плательщика (Click / Payme) *',
    sub_phone_hint: 'Только цифры: +998 (97) 325-07-70',
    sub_name_label: 'Ваше имя и фамилия (Необязательно)',
    sub_name_placeholder: 'Например: Али Валиев',
    sub_password_label: 'Создать пароль (Необязательно - для входа в будущем)',
    sub_password_placeholder: 'Не менее 6 символов',
    sub_receipt_label: 'Чек оплаты или скриншот (необязательно):',
    sub_receipt_select: 'Выберите чек (фото или PDF)',
    sub_receipt_uploading: 'Загрузка...',
    sub_receipt_attached: '✓ Чек успешно прикреплен',
    sub_notes_placeholder: 'ID транзакции или примечание (необязательно)...',
    sub_btn_cancel: 'Отмена',
    sub_btn_confirm: 'Я оплатил (Подтвердить)',
    sub_btn_verifying: 'Проверка...',
    sub_active_title: 'Оплата подтверждена и подписка активирована!',
    sub_active_desc: 'Ваш доступ успешно активирован на следующие 30 дней. Прямые контакты адвокатов и конфиденциальный чат открыты.',
    sub_continue: 'Продолжить',
    
    // Auth Modal
    auth_login_title: 'Вход в Систему',
    auth_login_subtitle: 'Для адвокатов, доверителей и администрации',
    auth_login_input_label: 'Логин, номер телефона или эл. почта',
    auth_login_input_placeholder: 'Логин, телефон или email',
    auth_password_label: 'Пароль',
    auth_password_placeholder: 'Не менее 6 символов',
    auth_2fa_title: 'Введите 2-й секретный пароль безопасности',
    auth_2fa_label: 'Пароль 2-го этапа',
    auth_btn_submit: 'ВОЙТИ В СИСТЕМУ',
    auth_btn_2fa_submit: 'ПОДТВЕРДИТЬ И ВОЙТИ',
    auth_new_user_title: 'Впервые на платформе?',
    auth_new_user_desc: 'Для получения юридической помощи, связи с адвокатами и открытия личного кабинета оформляется подписка на 30 дней.',
    auth_new_user_cta: 'Оплатить подписку и открыть аккаунт (35 000 сум)',
    auth_security_guarantee: 'Данные зашифрованы и защищены адвокатской тайной',
  },

  en: {
    // Navigation
    nav_home: 'Home',
    nav_about: 'About Attorneys',
    nav_services: 'Practices',
    nav_lawyers: 'Attorneys',
    nav_offices: 'Offices & Map',
    nav_contact: 'Contact',
    nav_book_cta: 'Book Appointment',
    nav_check_booking: 'Check Status',

    // Hero Section
    hero_badge: 'Premier National Legal Counsel & Advocacy',
    hero_category: 'Legal Solutions & Advocacy',
    hero_headline_1: 'Dedicated to Protecting',
    hero_headline_2: 'Your Rights',
    hero_headline: 'Dedicated to Protecting Your Rights',
    hero_subheadline: 'We provide strategic legal counsel and dedicated representation to individuals and businesses across complex commercial disputes, corporate transactions, and criminal defense in Uzbekistan.',
    hero_cta_book: 'Schedule Consultation',
    hero_cta_lawyers: 'Meet Our Attorneys',
    hero_cta_practice: 'Our Practice Areas',

    // Hero Benefit Badges
    badge_experienced: 'Experienced Attorneys',
    badge_experienced_desc: 'Decades of combined legal experience',
    badge_results: 'Proven Results',
    badge_results_desc: 'Successful outcomes in complex cases',
    badge_client: 'Client Focused',
    badge_client_desc: 'Personalized service & trusted guidance',

    // Quick Consultation Form (Hero Right)
    quick_consult_firm: 'Jizzakh Advocates',
    quick_consult_title: 'Quick Consultation',
    quick_consult_desc: 'Connect with a specialist for immediate legal counsel and case evaluation.',
    input_name: 'Full Name',
    input_email_opt: 'Email Address (optional)',
    input_reason_opt: 'Subject or brief question...',
    btn_submit_request: 'Submit Request',
    quick_success_title: 'Request Received!',
    quick_success_desc: 'Our attorneys will contact you shortly.',

    // Trust / Stats
    stat_years: 'Years of Practice',
    stat_cases: 'Resolved Matters',
    stat_lawyers: 'Partner Advocates',
    stat_trust: 'Client Trust Rating',

    // Middle Section ("We Fight For Justice")
    legal_ribbon_title: 'Website Design & Strategic Defense',
    fight_justice_title_1: 'We Fight For',
    fight_justice_title_2: 'Justice',
    fight_justice_desc: 'Our advocates team is built on a foundation of trust, integrity, and a relentless commitment to achieving justice for our clients.',
    btn_learn_more: 'About Attorneys',
    middle_statement_title: 'Deep Experience. Perfect Defense. Positive Results.',
    middle_statement_desc: 'Dependable trial defense at all investigation and judicial stages. Jizzakh city, Islam Karimov street, opposite Turon Bank. Phone: +998 (97) 325-07-70',
    consultation_free_badge: 'Free Consultation',

    // Practice Areas / Topics
    topic_criminal: 'Criminal Defense',
    topic_criminal_desc: 'Strategic defense of individuals and executives before investigating authorities, prosecutors, and all court tiers.',
    topic_injury: 'Personal Injury & Civil Claims',
    topic_injury_desc: 'Securing full financial restitution and moral damages for bodily injury, property loss, and wrongful institutional conduct.',
    topic_business: 'Business & Corporate Law',
    topic_business_desc: 'Company formation, commercial contracts, shareholder litigation, investments, and retainer outsourcing.',
    topic_family: 'Family & Estate Disputes',
    topic_family_desc: 'Equitable distribution of marital property, prenuptial agreements, inheritance disputes, and child custody advocacy.',
    topic_estate: 'Real Estate & Investments',
    topic_estate_desc: 'Comprehensive due diligence for commercial and residential real estate acquisitions, zoning, title disputes, and builder contracts.',

    // Section Titles
    sec_services_badge: 'Areas of Focus',
    sec_services_title: 'Core Legal Practice Areas',
    sec_services_desc: 'Comprehensive, high-stakes legal solutions tailored to corporations, financial institutions, and private clients.',
    sec_lawyers_badge: 'Our Leadership',
    sec_lawyers_title: 'Partners & Senior Advocates',
    sec_lawyers_desc: 'Seasoned attorneys with senior bar admissions and proven track records in domestic and international courts.',
    sec_why_badge: 'Guiding Principles',
    sec_why_title: 'Standards of Legal Practice',
    sec_testimonials_badge: 'Client Testimonials',
    sec_testimonials_title: 'Trusted by Industry Leaders',
    sec_offices_badge: 'Locations',
    sec_offices_title: 'Our Offices & Operating Schedule',

    // Lawyer Cards & Dossier
    lawyers_team_title: 'Our Senior Attorneys',
    view_all_lawyers: 'View All Attorneys',
    lawyer_detail_btn: 'Details →',
    lawyer_dossier_title: 'Attorney Dossier & Profile',
    lawyer_workplace: 'Office Location & Chamber',
    lawyer_contacts: 'Direct Communication Channels',
    lawyer_specialty: 'Specialization',
    lawyer_experience: 'Courtroom & Defense Experience',
    telegram_account: 'Telegram Account',
    instagram_account: 'Instagram Channel',
    qualifications_bio: 'Professional Qualifications & Bio',
    education_title: 'Legal Education',
    certifications_title: 'Bar Admissions & Licensure',

    // Online Booking Section
    online_booking_badge: 'ONLINE BOOKING',
    online_booking_title: 'Consultation Booking Portal',
    online_booking_desc: 'Select a convenient date and time. Our administration promptly reviews submissions and delivers official confirmation.',

    // Booking Steps
    step_1: 'Practice Area',
    step_2: 'Attorney',
    step_3: 'Office',
    step_4: 'Date & Time',
    step_5: 'Details',
    step_6: 'Reason',
    step_7: 'Confirmation',

    // Booking Form
    select_service: 'Select Legal Practice Area',
    select_lawyer: 'Select Attorney',
    select_office: 'Select Consultation Office',
    select_date_time: 'Select Preferred Date & Available Slot',
    your_name: 'Full Legal Name',
    your_phone: 'Direct Phone Number',
    your_email: 'Email Address',
    consultation_reason: 'Reason for Consultation',
    reason_placeholder: 'Please describe the legal subject matter in detail (minimum 10 characters)...',
    reason_hint: 'Minimum 10 characters required. This enables the advocate to prepare pertinent case research in advance.',
    slot_available: 'Available',
    slot_booked: 'Reserved',
    slot_break: 'Break',
    btn_next: 'Next Step',
    btn_prev: 'Previous',
    btn_confirm_submit: 'Submit Appointment Request',
    submitting: 'Submitting Request...',

    // Booking Confirmation
    booking_success_title: 'Appointment Request Received!',
    booking_ref_label: 'Your Booking Reference:',
    booking_status_label: 'Current Status:',
    booking_next_step: 'Our legal administration will review your appointment request and send an official confirmation note to your email and phone.',
    check_status_btn: 'Check Appointment Status',
    book_another_btn: 'Book Another Appointment',

    // Status Lookup
    lookup_title: 'Check Appointment Status',
    lookup_subtitle: 'Enter your booking reference and contact info to view real-time appointment status and attorney notes',
    lookup_ref_placeholder: 'e.g. APT-2026-000001',
    lookup_contact_placeholder: '+998 (97) 325-07-70',
    lookup_submit: 'Check Status',
    searching: 'Searching...',

    // Status Badges
    status_pending: 'Under Review (Pending)',
    status_confirmed: 'Confirmed (Scheduled)',
    status_rejected: 'Declined (Rejected)',
    status_cancelled: 'Cancelled',
    status_completed: 'Completed',
    status_no_show: 'No-show',

    // Common
    lawyer_experience_suffix: 'years of practice',
    view_details: 'View Profile',
    all_rights_reserved: 'All rights reserved',
    privacy_policy: 'Privacy Policy',
    terms_of_service: 'Terms of Use',
    disclaimer: 'Legal Disclaimer',
    contact_us: 'Contact Our Office',
    working_hours_label: 'Office Hours',
    admin_panel_title: 'Admin Management',

    // Extra UI & Booking & Modals
    my_profile: 'My Profile',
    auth_login: 'Sign In',
    logout: 'Sign Out',
    login_register: 'Sign In / Register',
    book_appointment_panel: 'BOOK AN APPOINTMENT',
    choose_date_time_panel: 'CHOOSE A DATE & TIME',
    your_information_panel: 'YOUR INFORMATION',
    submit_appointment_btn: 'SUBMIT APPOINTMENT',
    confirm_appointment_title: 'Confirm Appointment',
    confirm_appointment_subtitle: 'Please review your appointment details and confirm submission',
    confirm_btn_yes: 'YES, CONFIRM',
    cancel_btn: 'Cancel',
    service_and_lawyer: 'Practice Area & Lawyer:',
    date_and_time: 'Date & Time:',
    applicant: 'Applicant:',
    reason_for_visit: 'Reason for Consultation:',
    sms_notice_hint: 'After confirmation, your request is submitted to our administration. Upon review, an SMS is sent to your phone and an in-app alert is sent to your notification bell.',
    legal_solutions_tag: 'LEGAL SOLUTIONS',
    hero_title_p1: 'Dedicated to',
    hero_title_p2: 'Protecting Your',
    hero_title_highlight: 'Rights',
    hero_schedule_consult: 'SCHEDULE A CONSULTATION',
    hero_our_practices: 'OUR PRACTICE AREAS',
    reviews_badge: 'Client Testimonials',
    reviews_title: 'Client Feedback & Reviews',
    reviews_subtitle: 'Genuine testimonials from corporations and private clients represented in complex legal matters',
    practice_catalog_title: 'Practice Area Catalog',
    practice_overview: 'Overview of Legal Practice',
    practice_services_offered: 'Specific Legal Services Offered',
    stat_success_rate: 'Favorable trial and negotiation outcomes',
    stat_senior_exp: 'Senior courtroom advocacy tenure',
    stat_confidentiality: '100% Attorney-client privilege guarantee',
    lead_attorneys: 'Lead Attorneys in Charge',
    preliminary_review_time: 'Preliminary legal evaluation: within 24 hours',
    close_btn: 'Close',
    book_in_this_field: 'Book Consultation in this Area',
    firm_name_badge: 'JIZZAKH ADVOCATES',
    firm_location_brief: 'Jizzakh city, opposite Turon Bank',
    call_phone_number: 'Phone: +998 (97) 325-07-70',
    available_time_slots: 'Available Time Slots',
    slots_checking: 'Checking available slots...',
    no_slots_available: 'No available slots on this date. Please choose another day.',
    office_address_label: 'Address',
    office_phone_label: 'Phone',
    office_hours_label: 'Working Hours',
    office_book_btn: 'Schedule appointment at this office',
    corporate_client: 'Client',
    rate_lawyer_title: 'Rate Attorney & Feedback',
    rate_lawyer_subtitle: 'Rate the quality of legal representation from 1 to 5 stars and share your feedback',
    select_lawyer_label: 'Select Attorney *',
    select_lawyer_placeholder: '— Select Attorney —',
    rating_stars_label: 'Rating (1 to 5 stars) *',
    client_name_label: 'Full Legal Name *',
    client_name_placeholder: 'e.g. John Doe',
    client_title_label: 'Profession or Company (Optional)',
    client_title_placeholder: 'e.g. CEO, Delta Agro LLC',
    comment_label: 'Your Review & Comments (Required) *',
    comment_placeholder: 'Please describe the advocate’s counsel, trial strategy, and outcome (minimum 10 characters)...',
    submit_review_btn: 'Submit Rating & Review',
    review_submitted_title: 'Review Successfully Received!',
    review_submitted_subtitle: 'Thank you for your candid evaluation of our legal advocacy.',
    back_to_home: 'Back to Home',
    new_booking: 'Schedule New Appointment',
    client_portal_tag: 'CLIENT PORTAL',
    booking_id_label: 'Booking Reference ID *',
    phone_or_email_label: 'Phone Number or Email *',
    check_status_btn_text: 'Check Status',
    nav_book_short: 'Book',
    rate_lawyer_tooltip: 'Rate Attorney',
    admin_login_short: 'Admin',
    select_language: 'Select Language',
    about_philosophy_tag: 'OUR PHILOSOPHY & VALUES',
    about_mission_title: 'Our Mission & Legal Philosophy',
    about_mission_desc_1: 'Jizzakh Advocates is one of Uzbekistan’s leading legal practice teams. We deliver strategic counsel and dedicated representation for our clients’ rights and interests.',
    about_mission_desc_2: 'Our team members hold senior bar admissions and boast proven records in high-stakes corporate disputes, court litigation, and criminal defense.',
    pillar_rule_of_law: 'Rule of Law',
    pillar_rule_of_law_desc: 'Uncompromising advocacy within the full extent of the law to achieve maximum protection.',
    pillar_confidentiality: 'Strict Confidentiality',
    pillar_confidentiality_desc: 'Absolute attorney-client privilege and confidential handling of all documents and records.',
    pillar_results: 'Tangible Results',
    pillar_results_desc: 'Practical, battlefield-tested legal strategies delivering actual courtroom and transactional victories.',
    navigation_title: 'Navigation',
    developer_author_label: 'Developer & Author:',
    rating_1: '1 - Very Unsatisfactory',
    rating_2: '2 - Unsatisfactory',
    rating_3: '3 - Satisfactory',
    rating_4: '4 - Good',
    rating_5: '5 - Excellent (Highly Recommend)',
    office_details_title: 'Central Office Details',
    emergency_call_title: 'EMERGENCY ATTORNEY CALL (24/7)',
    emergency_call_desc: 'Urgent legal counsel and immediate response during arrest, interrogation, or emergency searches:',
    quick_msg_title: 'Send Quick Message',
    msg_content_label: 'Message Content',
    msg_content_placeholder: 'Briefly describe your legal inquiry or matter...',
    send_msg_btn: 'SEND MESSAGE',
    msg_sent_title: 'Your Message Has Been Received',
    msg_sent_desc: 'Our attorneys will get in touch with you shortly.',
    email_label: 'Email Address',
    phone_or_email_label: 'Phone Number',
    book_appointment_sub: 'Book Legal Consultation',
    free_consultation_badge: 'Free consultation available',
    notif_modal_badge: 'Notification Details',
    book_button: 'Book',
    phone_label: 'Phone Number',
    contact_page_desc: 'Contact us directly for inquiries or urgent legal assistance.',
    senior_partner: 'Senior Partner',
    office_phone_label: 'Office Phone',
    specialistsTag: 'ATTORNEYS & COUNSELORS AT LAW',
    bookConsultation: 'Book Consultation',

    // Auth & Subscription
    sub_monthly_menu: 'Monthly Subscription',
    lawyer_cabinet_menu: 'Attorney Portal',
    sub_modal_badge_client: 'Client Portal',
    sub_modal_badge_lawyer: 'Attorney Portal',
    sub_modal_title: '30-Day Monthly Subscription',
    sub_price_label: 'Exact monthly fee:',
    sub_tariff_client: '(Client tariff • 35,000 UZS/mo)',
    sub_tariff_lawyer: '(Attorney tariff • 99,000 UZS/mo)',
    sub_period_badge: '30 days access',
    sub_step1_title: 'Step 1: Pay via Click or Payme',
    sub_click_btn: 'Via Click Up',
    sub_payme_btn: 'Via Payme',
    sub_open_app: 'Open application',
    sub_card_label: 'Official card for P2P transfer:',
    sub_copy_card: 'Copy',
    sub_copied: 'Copied',
    sub_auto_copy_hint: 'Card number is automatically copied when you click Click or Payme.',
    sub_step2_title: 'Step 2: Phone number & confirmation',
    sub_complete_badge: 'Complete',
    sub_phone_label: 'Payer Phone Number (Click / Payme) *',
    sub_phone_hint: 'Digits only: +998 (97) 325-07-70',
    sub_name_label: 'Your Full Name (Optional)',
    sub_name_placeholder: 'e.g. John Doe',
    sub_password_label: 'Create Password (Optional - for future logins)',
    sub_password_placeholder: 'At least 6 characters',
    sub_receipt_label: 'Payment receipt or screenshot (optional):',
    sub_receipt_select: 'Select receipt (image or PDF)',
    sub_receipt_uploading: 'Uploading...',
    sub_receipt_attached: '✓ Receipt attached successfully',
    sub_notes_placeholder: 'Transaction ID or note (optional)...',
    sub_btn_cancel: 'Cancel',
    sub_btn_confirm: 'I have paid (Confirm)',
    sub_btn_verifying: 'Checking...',
    sub_active_title: 'Payment Confirmed & Subscription Active!',
    sub_active_desc: 'Your access is fully unlocked for the next 30 days. All attorney direct phone contacts and encrypted chat are now open.',
    sub_continue: 'Continue',
    
    // Auth Modal
    auth_login_title: 'Sign In',
    auth_login_subtitle: 'For attorneys, clients, and administration',
    auth_login_input_label: 'Login, Phone Number, or Email',
    auth_login_input_placeholder: 'Login, phone, or email',
    auth_password_label: 'Password',
    auth_password_placeholder: 'At least 6 characters',
    auth_2fa_title: 'Enter 2-step secret security password',
    auth_2fa_label: 'Step-2 Password',
    auth_btn_submit: 'SIGN IN',
    auth_btn_2fa_submit: 'CONFIRM & SIGN IN',
    auth_new_user_title: 'New client?',
    auth_new_user_desc: 'To access legal counsel, connect directly with attorneys, and create your account, activate a 30-day subscription.',
    auth_new_user_cta: 'Pay Subscription & Open Account (35,000 UZS)',
    auth_security_guarantee: 'Data is encrypted and strictly protected by attorney-client privilege',
  },
};
